import { connect } from 'react-redux';
import { IState } from '../../../reducers';
import { SpinnerComponent } from './spinner';

const mapStateToProps = (state: IState) => ({
  showSpinner: state.http.inProgress,
});

export const SpinnerContainer = connect(
  mapStateToProps,
)(SpinnerComponent);


// WEBPACK FOOTER //
// ./src/common/components/spinner/spinnerContainer.tsx